<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128.4 81.36">
        <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_4" data-name="Layer 4">
                <path
                    d="M125.24.71A5.83,5.83,0,0,0,122.43,0H6a5.77,5.77,0,0,0-2.8.71A6,6,0,0,0,0,6V75.39a6,6,0,0,0,6,6H122.43a6,6,0,0,0,6-6V6A6,6,0,0,0,125.24.71Zm-3.3,69.61a4.15,4.15,0,0,1-5.06,6.58L77.29,46.47,70.14,52a9.9,9.9,0,0,1-11.88,0l-7.15-5.5L11.52,76.9a4.15,4.15,0,1,1-5.06-6.58L44.3,41.23,6.46,12.15a4.15,4.15,0,0,1,5.06-6.58L53.71,38l9.61,7.38a1.53,1.53,0,0,0,1.76,0l51.8-39.81a4.15,4.15,0,1,1,5.06,6.58L84.1,41.23Z"
                    fill="#727373"
                />
            </g>
        </g>
    </svg>
</template>
<script>
export default {};
</script>



// WEBPACK FOOTER //
// MailIcon.vue?4424bcaa